@if (canSeeLeaflogix) {
  <button mat-menu-item
    title="Link active batches in Dutchie to Harvest schedules"
    [disabled]="disabled"
    (click)="checkHarvests()"
    >
    <mat-icon>link</mat-icon>
    <span>Link Dutchie Batches</span>
  </button>
}